import script from "./PerformerProjectFormStep5.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectFormStep5.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectFormStep5.vue?vue&type=style&index=0&id=7efcfb7d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7efcfb7d"]])

export default __exports__